import type { AssessmentListItem } from '@assessments/shared'
import { Badge } from '@/components/ui/badge'
import { Card } from '@/components/ui/card'
import { formatDeadline } from '@/lib/formatDeadline'
import { AssessmentCardAction } from './AssessmentCardAction.js'
import { SUBMISSION_STATUS_BADGE } from './submissionStatus.js'

/** One assessment on the Manage Assessments page. Only the action navigates. */
export function AssessmentCard({ item, canEdit }: { item: AssessmentListItem; canEdit: boolean }) {
  const badge = SUBMISSION_STATUS_BADGE[item.status]
  const pastDue = item.deadline.state === 'past_due'
  return (
    <Card
      as="article"
      data-status={item.status}
      className="flex flex-wrap items-center justify-between gap-6 p-8 shadow-card max-sm:p-5"
    >
      <div className="min-w-0 flex-1 basis-72">
        <Badge tone={badge.tone} size="md">
          {badge.label}
        </Badge>
        <h2 className="mt-3 mb-2 font-jakarta text-[22px] leading-tight font-bold text-heading">
          {item.title}
        </h2>
        <p className="text-[15px] text-body">
          <span>
            Deadline: <span>{formatDeadline(item.deadline)}</span>
            {pastDue && <span className="ml-1.5 text-danger">Past due</span>}
          </span>
          <span aria-hidden="true" className="mx-2">
            ·
          </span>
          <span>
            {item.sectionsCompleteCount} of {item.sectionsTotalCount} sections completed
          </span>
        </p>
      </div>
      <div className="shrink-0">
        <AssessmentCardAction item={item} canEdit={canEdit} />
      </div>
    </Card>
  )
}
